import { render, staticRenderFns } from "./scene12.vue?vue&type=template&id=72cd259b&scoped=true&"
import script from "./scene12.vue?vue&type=script&lang=ts&"
export * from "./scene12.vue?vue&type=script&lang=ts&"
import style0 from "./scene12.vue?vue&type=style&index=0&id=72cd259b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cd259b",
  null
  
)

export default component.exports